import { render, staticRenderFns } from "./showImage.vue?vue&type=template&id=c34172c2&scoped=true&"
import script from "./showImage.vue?vue&type=script&lang=js&"
export * from "./showImage.vue?vue&type=script&lang=js&"
import style0 from "./showImage.vue?vue&type=style&index=0&id=c34172c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34172c2",
  null
  
)

export default component.exports